<template>
  <el-row 
    id="close-restaurant-page" 
    class="fs-site d-flex" 
    style="width: inherit;"
  >
      <div class="px--5 my--auto pb--15">
        <el-col class="text-xs-center">
          <img :src="require('@/assets/icons/restaurant_close.png')" width="50%">
        </el-col>
        <el-col class="text-xs-center pt--3">
          <label class="text-title">{{ $t('pageNotFound.title1') }}</label><br>
          <label class="text-title">{{ $t('pageNotReciveOrder.title') }}</label>
        </el-col>
        <el-col class="text-xs-center py--3">
          <BaseButton 
            @click="backToRestaurant"
            class="color-primary color-white--text"
          >
            <template #prefix>
              <i class="fas fa-chevron-circle-left"></i>
            </template>
            <span class="pl--1">{{ $t('pageNotReciveOrder.back') }}</span>
          </BaseButton>
        </el-col>
      </div>
      <el-row class="footer-container">
        <div class="d-flex align-end pt--3" style="border-top: 0.5px dashed #888888;">
          <el-col :span="18">
            <h4 class="text-heading3--bold" v-html="$t('pageNotReciveOrder.contactDescription')"></h4>
            <img :src="require('@/assets/icons/svg/logo-foodstory.svg')" />
          </el-col>
          <el-col :span="6" class="text-xs-end">
            <BaseButton 
              @click="goToContact"
              class="color-primary--text color-primary--border py--1 px--6 mb--2"
            >
                {{ $t('pageNotReciveOrder.contact') }}
            </BaseButton>
          </el-col>
        </div>
      </el-row>
  </el-row>
</template>

<script>
import BaseButton from '@/baseComponents/button/BaseButton.vue'

export default {
  name: 'PageNotReciveOrder',
  components: {
    BaseButton
  },
  mounted: function() {
    this.$nextTick(() => {
      this.resize()
      window.addEventListener('resize', this.resize)
    })
  },
  destroyed: function() {
    window.removeEventListener('resize')
  },
  methods: {
    resize: function() {
      document.querySelector('#close-restaurant-page').style.height = window.innerHeight + "px";
    },
    goToContact: function() {
      window.open('https://bit.ly/onlineorderfootpage')
    },
    backToRestaurant: function() {
      const { uuid = '' } = JSON.parse(localStorage.getItem('restaurant') || '{}')
      this.$router.push(`/restaurant/${uuid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  position: fixed !important;
  width: inherit;
  bottom: 0;
  background-color: white;
  padding: 0 24px 24px 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/PageNotReciveOrder.vue